import { ReportCustomizationReducerAction } from "./interfaces/reportCustomizationReducerAction";
import { ReportCustomizationReducerActions } from "./interfaces/reportCustomizationReducerActionsEnum";
import { ReportCustomizationState } from "./interfaces/reportCustomizationState";

export const reportCustomizationReducer: React.Reducer<ReportCustomizationState, ReportCustomizationReducerAction> = (state, action) => {
  switch (action.type) {
    case ReportCustomizationReducerActions.ChangeAppendNextClosestProviders:
      return {
        ...state,
        appendNextClosestProviders: action.payload.appendNextClosestProviders,
      };
    case ReportCustomizationReducerActions.ChangeAppendPatternOfCare:
      return {
        ...state,
        appendPatternOfCareProviders: action.payload.appendPatternOfCareProviders,
      };
    case ReportCustomizationReducerActions.ChangeFileFormat:
      return {
        ...state,
        appendPatternOfCareProviders: action.payload.appendPatternOfCareProviders,
        fileFormat: action.payload.fileFormat,
        reportFormat: action.payload.reportFormat,
      };
    case ReportCustomizationReducerActions.ChangeChangedGapsFilter:
      return {
        ...state,
        changedGapsType: action.payload.changedGapsType,
        includeActive: action.payload.includeActive,
        includeApproved: action.payload.includeApproved,
        includeFacilitySpecialties: action.payload.includeFacilitySpecialties,
        includeOpportunity: action.payload.includeOpportunity,
        includePending: action.payload.includePending,
        includePhysicianSpecialties: action.payload.includePhysicianSpecialties,
        selectedCounties: action.payload.selectedCounties,
        selectedSpecialties: action.payload.selectedSpecialties,
        selectedStates: action.payload.selectedStates,
        serviceAreaGapsType: action.payload.serviceAreaGapsType,
        specialtyGapsType: action.payload.specialtyGapsType,
      };
    case ReportCustomizationReducerActions.ChangeFilename:
      return {
        ...state,
        filename: action.payload.filename,
      };
    case ReportCustomizationReducerActions.ChangeIncludeActive:
      return {
        ...state,
        includeActive: action.payload.includeActive,
        networkAssessmentAnalysisTypes: action.payload.networkAssessmentAnalysisTypes,
      };
    case ReportCustomizationReducerActions.ChangeIncludeApproved:
      return {
        ...state,
        includeApproved: action.payload.includeApproved,
        networkAssessmentAnalysisTypes: action.payload.networkAssessmentAnalysisTypes,
      };
    case ReportCustomizationReducerActions.ChangeIncludeCargo:
      return {
        ...state,
        includeCargo: action.payload.includeCargo,
      };
    case ReportCustomizationReducerActions.ChangeIncludeExpandableSpecialties:
      return {
        ...state,
        includeExpandableSpecialties: action.payload.includeExpandableSpecialties,
      };
    case ReportCustomizationReducerActions.ChangeIncludeFacilitySpecialties:
      return {
        ...state,
        includeFacilitySpecialties: action.payload.includeFacilitySpecialties,
      };
    case ReportCustomizationReducerActions.ChangeIncludeOpportunity:
      return {
        ...state,
        includeOpportunity: action.payload.includeOpportunity,
        networkAssessmentAnalysisTypes: action.payload.networkAssessmentAnalysisTypes,
      };
    case ReportCustomizationReducerActions.ChangeIncludePending:
      return {
        ...state,
        includePending: action.payload.includePending,
        networkAssessmentAnalysisTypes: action.payload.networkAssessmentAnalysisTypes,
      };
    case ReportCustomizationReducerActions.ChangeIncludePhysicianSpecialties:
      return {
        ...state,
        includePhysicianSpecialties: action.payload.includePhysicianSpecialties,
      };
    case ReportCustomizationReducerActions.ChangeIsCompareMode:
      return {
        ...state,
        appendNextClosestProviders: action.payload.appendNextClosestProviders,
        appendPatternOfCareProviders: action.payload.appendPatternOfCareProviders,
        changedGapsType: action.payload.changedGapsType,
        comparedTimeslice: action.payload.comparedTimeslice,
        filename: action.payload.filename,
        isCompareMode: action.payload.isCompareMode,
        providerFilter: action.payload.providerFilter,
        providerSource: action.payload.providerSource,
        reportFormat: action.payload.reportFormat,
        selectedMemberships: action.payload.selectedMemberships,
        showAddedProviders: action.payload.showAddedProviders,
        showMatchedProviders: action.payload.showMatchedProviders,
        showRemovedProviders: action.payload.showRemovedProviders,
      };
    case ReportCustomizationReducerActions.ChangeIsGenerating:
      return {
        ...state,
        isGenerating: action.payload.isGenerating,
      };
    case ReportCustomizationReducerActions.ChangeLoadedPresets:
      return {
        ...state,
        presets: action.payload.presets,
      };
    case ReportCustomizationReducerActions.ChangeMemberships:
      return {
        ...state,
        appendNextClosestProviders: action.payload.appendNextClosestProviders,
        appendPatternOfCareProviders: action.payload.appendPatternOfCareProviders,
        changedGapsType: action.payload.changedGapsType,
        comparedTimeslice: action.payload.comparedTimeslice,
        filename: action.payload.filename,
        isCompareMode: action.payload.isCompareMode,
        providerFilter: action.payload.providerFilter,
        providerSource: action.payload.providerSource,
        reportFormat: action.payload.reportFormat,
        selectedMemberships: action.payload.selectedMemberships,
        showAddedProviders: action.payload.showAddedProviders,
        showMatchedProviders: action.payload.showMatchedProviders,
        showRemovedProviders: action.payload.showRemovedProviders,
      };
    case ReportCustomizationReducerActions.ChangeProviderFilter:
      return {
        ...state,
        providerFilter: action.payload.providerFilter,
      };
    case ReportCustomizationReducerActions.ChangeProviderSource:
      return {
        ...state,
        appendNextClosestProviders: action.payload.appendNextClosestProviders,
        appendPatternOfCareProviders: action.payload.appendPatternOfCareProviders,
        filename: action.payload.filename,
        providerFilter: action.payload.providerFilter,
        providerSource: action.payload.providerSource,
        reportFormat: action.payload.reportFormat,
      };
    case ReportCustomizationReducerActions.ChangeReportFormat:
      return {
        ...state,
        appendPatternOfCareProviders: action.payload.appendPatternOfCareProviders,
        reportFormat: action.payload.reportFormat,
      };
    case ReportCustomizationReducerActions.ChangeReportType:
      return {
        ...state,
        ...action.payload,
      };
    case ReportCustomizationReducerActions.ChangeSelectedPreset:
      return {
        ...state,
        selectedPreset: action.payload.selectedPreset,
      };
    case ReportCustomizationReducerActions.ChangeSelectedCounties:
      return {
        ...state,
        selectedCounties: action.payload.selectedCounties,
      };
    case ReportCustomizationReducerActions.ChangeSelectedSpecialtes:
      return {
        ...state,
        selectedSpecialties: action.payload.selectedSpecialties,
      };
    case ReportCustomizationReducerActions.ChangeSelectedStates:
      return {
        ...state,
        selectedStates: action.payload.selectedStates,
      };
    case ReportCustomizationReducerActions.ChangeServiceAreaGapsType:
      return {
        ...state,
        serviceAreaGapsType: action.payload.serviceAreaGapsType,
      };
    case ReportCustomizationReducerActions.ChangeSharedUsers:
      return {
        ...state,
        sharedUsers: action.payload.sharedUsers,
      };
    case ReportCustomizationReducerActions.ChangeShouldEmailLink:
      return {
        ...state,
        shouldEmailLink: action.payload.shouldEmailLink,
      };
    case ReportCustomizationReducerActions.ChangeShowAddedProviders:
      return {
        ...state,
        showAddedProviders: action.payload.showAddedProviders,
      };
    case ReportCustomizationReducerActions.ChangeShowMatchedProviders:
      return {
        ...state,
        showMatchedProviders: action.payload.showMatchedProviders,
      };
    case ReportCustomizationReducerActions.ChangeShowRemovedProviders:
      return {
        ...state,
        showRemovedProviders: action.payload.showRemovedProviders,
      };
    case ReportCustomizationReducerActions.ChangeSpecialtyGapsType:
      return {
        ...state,
        specialtyGapsType: action.payload.specialtyGapsType,
      };
    case ReportCustomizationReducerActions.ChangeTimeslice:
    case ReportCustomizationReducerActions.ChangeComparedTimeslice:
      return {
        ...state,
        allMemberships: action.payload.allMemberships,
        allServiceAreaCounties: action.payload.allServiceAreaCounties,
        allServiceAreaStates: action.payload.allServiceAreaStates,
        allSpecialties: action.payload.allSpecialties,
        changedGapsType: action.payload.changedGapsType,
        comparedTimeslice: action.payload.comparedTimeslice,
        filename: action.payload.filename || state.filename,
        isCompareMode: action.payload.isCompareMode === undefined ? state.isCompareMode : action.payload.isCompareMode,
        providerSource: action.payload.providerSource || state.providerSource,
        reportFormat: action.payload.reportFormat,
        selectedCounties: action.payload.selectedCounties,
        selectedMemberships: action.payload.selectedMemberships,
        selectedSpecialties: action.payload.selectedSpecialties,
        showAddedProviders: action.payload.showAddedProviders === undefined ? state.showAddedProviders : action.payload.showAddedProviders,
        showMatchedProviders: action.payload.showMatchedProviders === undefined ? state.showMatchedProviders : action.payload.showMatchedProviders,
        showRemovedProviders: action.payload.showRemovedProviders === undefined ? state.showRemovedProviders : action.payload.showRemovedProviders,
        timeslice: action.payload.timeslice,
      };
    case ReportCustomizationReducerActions.LoadPage:
      return {
        ...state,
        allServiceAreaCounties: action.payload.allServiceAreaCounties,
        allServiceAreaStates: action.payload.allServiceAreaStates,
        allSpecialties: action.payload.allSpecialties,
        allTimeslices: action.payload.allTimeslices,
        presets: action.payload.presets,
        selectedCounties: action.payload.selectedCounties,
        selectedSpecialties: action.payload.selectedSpecialties,
        selectedStates: action.payload.selectedStates,
        showNetNewProviders: action.payload.showNetNewProviders,
      };
    default:
      return state;
  }
}